import React from "react";
import { Header, Form, Dropdown, Button } from "semantic-ui-react";
import { translate } from "react-i18next";

const SearchForm = (props) => {
  const { t } = props;
  let options = [
    {
      key: "1",
      text: t("placement_efficiency.search_by.plant") || "Plant",
      value: t("placement_efficiency.search_by.plant") || "Plant",
    },
    {
      key: "1",
      text: t("placement_efficiency.search_by.depot") || "Depot",
      value: t("placement_efficiency.search_by.depot") || "Depot",
    },
    {
      key: "1",
      text: t("placement_efficiency.search_by.zone") || "Zone",
      value: t("placement_efficiency.search_by.zone") || "Zone",
    },
    {
      key: "1",
      text: t("placement_efficiency.search_by.weeks") || "Weeks",
      value: t("placement_efficiency.search_by.weeks") || "Weeks",
    },
    {
      key: "1",
      text: t("placement_efficiency.search_by.month") || "Month",
      value: t("placement_efficiency.search_by.month") || "Month",
    },
    {
      key: "1",
      text: t("placement_efficiency.search_by.vendor") || "Vendor",
      value: t("placement_efficiency.search_by.vendor") || "Vendor",
    },
  ];

  return (
    <React.Fragment>
      <Header
        as="h3"
        className="labelName"
        color="#333"
        dividing
        textAlign="center"
      >
        {t("placement_efficiency.title") || "PLACEMENT EFFICIENCY"}
      </Header>
      <Form size="mini" className="p-2">
        <Form.Group inline widths={4}>
          <Form.Field />
          <Form.Field width={2}></Form.Field>
          <Form.Field>
            <Dropdown
              placeholder={t('placement_efficiency.search_by.placeholder') || "Search By"}
              fluid
              selection
              options={options}
            />
          </Form.Field>
          <Form.Field width={3}>
            <Button size="mini" primary basic>
              {" "}
              {t("placement_efficiency.action_button.apply") || "Apply"}
            </Button>
          </Form.Field>
        </Form.Group>
      </Form>
    </React.Fragment>
  );
};

export default translate("dashboard")(SearchForm);
